module.exports = __webpack_public_path__ + "img/edit.bf69bc74.png";